<template>
  <o-form-wrapper
    v-model="item"
    :form-state="formState"
    :schema="schema"
    :server-errors="_se"
    :v="$v.item"
  >
    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="id"
    >
      <o-text-field
        v-model="item.id"
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="id"
        readonly
        v-bind="schema.fields.id"
      ></o-text-field>
    </o-widget-wrapper>
    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="on_hold"
    >
      <o-checkbox
        v-model="item.on_hold"
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="on_hold"
        v-bind="schema.fields.on_hold"
      ></o-checkbox>
    </o-widget-wrapper>
    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="customer"
    >
      <o-select
        v-model="item.customer"
        :form-state="formState"
        :items="optionCustomerItems"
        :loading="optionCustomerWorking"
        :server-errors="_se"
        :validators="$v.item"
        add-title="Create New"
        allow-add
        name="customer"
        sort-field="name"
        store-name="Customer"
        text-field="name"
        v-bind="schema.fields.customer"
        value-field="id"
      >
        <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <customer-form
            :form-state="formState"
            :item="item"
            :server-errors="serverErrors"
            in-modal
          ></customer-form>
        </template>
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="order_date"
    >
      <o-date-time
        v-model="item.order_date"
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="order_date"
        v-bind="schema.fields.order_date"
      ></o-date-time>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="po_number"
    >
      <o-text-field
        v-model="item.po_number"
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="po_number"
        v-bind="schema.fields.po_number"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="delivery_address"
    >
      <o-text-field
        v-model="item.delivery_address"
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="delivery_address"
        v-bind="schema.fields.delivery_address"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="map_ref"
    >
      <o-text-field
        v-model="item.map_ref"
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="map_ref"
        v-bind="schema.fields.map_ref"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="area"
    >
      <o-select
        v-model="item.area"
        :form-state="formState"
        :items="optionCodeAreaItems"
        :loading="optionCodeAreaWorking"
        :server-errors="_se"
        :validators="$v.item"
        name="area"
        sort-field="code"
        text-field="code"
        v-bind="schema.fields.area"
        value-field="id"
      >
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="on_site_contact"
    >
      <o-select
        v-model="item.on_site_contact"
        :form-state="formState"
        :items="on_site_customer_list"
        :loading="optionOnSiteContactWorking"
        :server-errors="_se"
        :validators="$v.item"
        add-title="Create On Site Contact"
        allow-add
        name="on_site_contact"
        sort-field="display_name"
        store-name="OnSiteContact"
        text-field="display_name"
        v-bind="schema.fields.on_site_contact"
        value-field="id"
      >
        <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <on-site-contact-form
            :form-state="formState"
            :item="item"
            :server-errors="serverErrors"
            in-modal
          ></on-site-contact-form>
        </template>
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="delivery_instructions"
    >
      <o-text-field
        v-model="item.delivery_instructions"
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="delivery_instructions"
        v-bind="schema.fields.delivery_instructions"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="requested_delivery_date_time_of_day"
    >
      <o-select
        v-model="item.requested_delivery_date_time_of_day"
        :form-state="formState"
        :items="optionCodeTimeOfDayItems"
        :loading="optionCodeTimeOfDayWorking"
        :server-errors="_se"
        :validators="$v.item"
        name="requested_delivery_date_time_of_day"
        sort-field="description"
        text-field="description"
        v-bind="schema.fields.requested_delivery_date_time_of_day"
        value-field="id"
      >
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="requested_delivery_date"
    >
      <o-date-time
        v-model="item.requested_delivery_date"
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        hide-time
        name="requested_delivery_date"
        v-bind="schema.fields.requested_delivery_date"
      ></o-date-time>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="scrap_pickup"
    >
      <o-checkbox
        v-model="item.scrap_pickup"
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="scrap_pickup"
        v-bind="schema.fields.scrap_pickup"
      ></o-checkbox>
    </o-widget-wrapper>

    <o-widget-wrapper
      v-if="item.scrap_pickup"
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="requested_scrap_pickup_date"
    >
      <o-date-time
        v-model="item.requested_scrap_pickup_date"
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        hide-time
        name="requested_scrap_pickup_date"
        v-bind="schema.fields.requested_scrap_pickup_date"
      ></o-date-time>
    </o-widget-wrapper>

    <o-widget-wrapper
      v-if="item.scrap_pickup"
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="requested_scrap_pickup_time_of_day"
    >
      <o-select
        v-model="item.requested_scrap_pickup_time_of_day"
        :form-state="formState"
        :items="optionCodeTimeOfDayItems"
        :loading="optionCodeTimeOfDayWorking"
        :server-errors="_se"
        :validators="$v.item"
        name="requested_scrap_pickup_time_of_day"
        sort-field="description"
        text-field="description"
        v-bind="schema.fields.requested_scrap_pickup_time_of_day"
        value-field="id"
      >
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="invoice_no"
    >
      <o-text-field
        v-model="item.invoice_no"
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="invoice_no"
        v-bind="schema.fields.invoice_no"
      ></o-text-field>
    </o-widget-wrapper>

    <o-section v-if="item.when" :level="0" title="Upstream">
      <o-widget-wrapper
        :form-state="formState"
        :schema="schema"
        :server-errors="_se"
        :validators="$v.item"
        name="when"
      >
        <o-date-time
          v-model="item.when"
          :form-state="formState"
          :server-errors="_se"
          :validators="$v.item"
          hide-time
          name="when"
          readonly
          v-bind="schema.fields.when"
        ></o-date-time>
      </o-widget-wrapper>

      <o-widget-wrapper
        :form-state="formState"
        :schema="schema"
        :server-errors="_se"
        :validators="$v.item"
        name="longitude"
      >
        <o-text-field
          v-model="item.longitude"
          :form-state="formState"
          :server-errors="_se"
          :validators="$v.item"
          name="longitude"
          readonly
          v-bind="schema.fields.longitude"
        ></o-text-field>
      </o-widget-wrapper>

      <o-widget-wrapper
        :form-state="formState"
        :schema="schema"
        :server-errors="_se"
        :validators="$v.item"
        name="latitude"
      >
        <o-text-field
          v-model="item.latitude"
          :form-state="formState"
          :server-errors="_se"
          :validators="$v.item"
          name="latitude"
          readonly
          v-bind="schema.fields.latitude"
        ></o-text-field>
      </o-widget-wrapper>

      <a :href="mapsURL"
         class="btn btn-block btn-secondary"
         target="_blank"
         title="Open in Google Maps">
        <GoogleMapsIcon/>
        Open in Google Maps</a>
    </o-section>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="job_task_job"
    >
      <job-task-form-table
        v-model="item.job_task_job"
        :form-state="formState"
        :job="item"
        :label="schema.fields.job_task_job.label"
        :server-errors="_se.job_task_job"
        :validators="$v.item.job_task_job"
      >
      </job-task-form-table>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="notes"
    >
      <o-notes-table
        v-model="item.notes"
        :form-state="formState"
        :label="schema.fields.notes.label"
        :level="level + 1"
        :server-errors="_se.notes"
        :users="optionUserItemsById"
        :users-working="optionUserWorking"
        :validator="$v.item.notes"
        model-name="JobNote"
        when-field="when"
        who-field="who"
      >
      </o-notes-table>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="products"
    >
      <job-product-form-table
        v-model="item.products"
        :form-state="formState"
        :label="schema.fields.products.label"
        :level="level + 1"
        :server-errors="_se[schema.fields.products.name]"
        :validators="$v.item.products"
      >
      </job-product-form-table>
      <!-- UNCOMMENT TO USE Cards
      <job-product-form-table v-model="item.products"
          :validators="$v.item.products"
          :form-state="formState"
          :label="schema.fields.products.label"
          :level="level+1"
          :server-errors="_se[schema.fields.products.name]">
      </job-product-form-cards>
      -->
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="files"
    >
      <o-files-table
        v-model="item.files"
        :file-types="optionCodeFileTypeItems"
        :file-types-working="optionCodeFileTypeWorking"
        :form-state="formState"
        :label="schema.fields.files.label"
        :level="level + 1"
        :other-id="item.id"
        :server-errors="_se[schema.fields.files.name]"
        :users="optionUserItemsById"
        :users-working="optionUserWorking"
        :validator="$v.item.files"
        model-name="JobFile"
        other-name="job_file"
        when-field="created_date"
        who-field="created_user"
      >
      </o-files-table>
    </o-widget-wrapper>
  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index";
import {cleanUpModel} from "../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../vue-ocom/mixins";
import {validationMixin} from "vuelidate";
import OWidgetWrapper from "../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../vue-ocom/components/forms/fields/OTextField";
import OSelect from "../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../vue-ocom/components/forms/fields/ODateTime";
import GoogleMapsIcon from 'vue-material-design-icons/GoogleMaps';

import {default as CustomerForm} from "../../customer/components/ItemForm";
import {default as OnSiteContactForm} from "../../on_site_contact/components/ItemForm";
import {default as JobProductFormTable} from "../../job_product/components/ItemFormTable";
import ONotesTable from "../../../vue-ocom/components/table/common/ONotesTable";
import OFilesTable from "../../../vue-ocom/components/table/common/OFilesTable";
import JobTaskFormTable from "../../job_task/components/ItemFormTable";

export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("Job"),
    CreateCodeTableFetchMixin([
      "Customer",
      "OnSiteContact",
      "CodeArea",
      "CodeTimeOfDay",
      "User",
      "CodeFileType",
    ]),
  ],
  components: {
    JobTaskFormTable,
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextField,

    GoogleMapsIcon,

    CustomerForm,
    OnSiteContactForm,
    JobProductFormTable,
    //JobProductFormCards,
    ONotesTable,
    OFilesTable,
  },
  props: {
    item: {
      type: Object,
      default: () => {
      },
    },
    level: {type: Number, default: 0},
    inModal: {type: Boolean, default: false},
  },
  data: () => ({
    schemaModel: cleanUpModel(schema.Job, {}),
  }),
  methods: {},
  computed: {
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
    on_site_customer_list() {
      var result = this.optionOnSiteContactItems;

      _.each(result, function (o) {
        o.display_name = ((o.name || "") + " " + (o.phone_number || "")).trim();
      });

      return result;
    },
    mapsURL() {
      return "https://www.google.com/maps/search/?api=1&query=" + this.item.latitude + "," + this.item.longitude;
    },
  },
  watch: {},
  created() {
  },
};
</script>
